import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: PublicPage,
});

function PublicPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans selection:bg-sky-500 selection:text-white">
      {/* Navigation */}
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800/80 px-6 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-linear-to-br from-indigo-500 to-sky-400 flex items-center justify-center font-black text-lg text-white shadow-lg shadow-indigo-500/30">
              M
            </div>
            <div>
              <div className="font-bold text-lg tracking-tight bg-linear-to-r from-white to-slate-400 bg-clip-text text-transparent">
                MyBusinessMate
              </div>
              <div className="text-[10px] font-mono text-sky-400 tracking-wider">mybusinessmate.ai</div>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-300">
            <a href="#services" className="hover:text-white transition">
              Services
            </a>
            <a href="#pricing" className="hover:text-white transition">
              Pricing
            </a>
            <a href="#consultation" className="hover:text-white transition">
              Free Chai
            </a>
            <a href="#about" className="hover:text-white transition">
              About
            </a>
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/subdomain/app"
              className="px-4 py-2 rounded-xl text-xs font-semibold bg-slate-900 border border-slate-700 hover:border-slate-500 text-slate-200 transition"
            >
              Client Login (app.*)
            </Link>
            <Link
              to="/subdomain/admin"
              className="px-4 py-2 rounded-xl text-xs font-semibold bg-indigo-600 hover:bg-indigo-500 text-white transition shadow-lg shadow-indigo-600/30"
            >
              Agency Staff (admin.*)
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-1 max-w-6xl mx-auto px-6 py-20 flex flex-col items-center text-center space-y-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-500/10 border border-sky-500/20 text-xs text-sky-400 font-medium">
          <span className="h-2 w-2 rounded-full bg-sky-400 animate-pulse" />
          The Modern Enterprise Operating System for MSMEs
        </div>

        <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight max-w-4xl text-white leading-tight">
          Website, Marketing & Automation —{' '}
          <span className="bg-linear-to-r from-sky-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
            All In One Unified Engine
          </span>
        </h1>

        <p className="text-base sm:text-lg text-slate-400 max-w-2xl leading-relaxed">
          Stop juggling fragmented agencies, freelance chaos, and multiple monthly bills. Get dedicated senior
          developers, designers, and growth experts for a flat, predictable monthly subscription.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 pt-4">
          <Link
            to="/subdomain/app"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl font-semibold bg-linear-to-r from-sky-500 to-indigo-600 hover:from-sky-400 hover:to-indigo-500 text-white shadow-xl shadow-sky-500/25 transition transform hover:-translate-y-0.5 text-center"
          >
            Launch Client Portal (app.mybusinessmate.ai)
          </Link>
          <a
            href="#pricing"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl font-semibold bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-200 transition"
          >
            Explore Plans (Basic, Plus, Pro)
          </a>
        </div>

        {/* Feature Grid */}
        <div id="services" className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-16 w-full text-left">
          <div className="p-6 rounded-2xl bg-slate-900/60 border border-slate-800/80 hover:border-slate-700 transition space-y-3">
            <div className="text-3xl">🌐</div>
            <h3 className="text-lg font-bold text-white">Full-Stack Websites</h3>
            <p className="text-sm text-slate-400">
              Modern high-speed web apps with SSL, SSR edge performance, responsive mobile design, and automated monthly
              maintenance.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-slate-900/60 border border-slate-800/80 hover:border-slate-700 transition space-y-3">
            <div className="text-3xl">📈</div>
            <h3 className="text-lg font-bold text-white">Growth & Social Media</h3>
            <p className="text-sm text-slate-400">
              High-converting Instagram reels, automated post scheduling, Google Business Profile optimization, and Meta
              Graph analytics.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-slate-900/60 border border-slate-800/80 hover:border-slate-700 transition space-y-3">
            <div className="text-3xl">☕</div>
            <h3 className="text-lg font-bold text-white">Free Chai Consultations</h3>
            <p className="text-sm text-slate-400">
              Meet our team at Moguls Court Building, Hyderabad, or via Google Meet for 1-on-1 strategy sessions,
              completely on the house.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-800/80 py-8 px-6 text-center text-xs text-slate-400">
        <p>© 2026 MyBusinessMate AI. Registered in Hyderabad, Telangana. All rights reserved.</p>
      </footer>
    </div>
  );
}
